<script setup lang="ts">
import { onMounted } from 'vue';
import AppShell from './AppShell.vue';
import LoginPage from './LoginPage.vue';
import LoadingPanel from '@/components/LoadingPanel.vue';
import { useAppStore } from '@/stores/app';
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();
const app = useAppStore();

onMounted(async () => {
  await Promise.all([auth.restore(), app.loadVersion()]);
});
</script>

<template>
  <LoadingPanel v-if="!auth.initialized" loading />
  <!--
    后端不可达（重启中 / 网络故障）且令牌仍有效时：给「重试」入口，而不是把人赶到登录页。
    只有明确的 401（未登录 / 令牌过期）才会落到下面的 LoginPage。
  -->
  <div v-else-if="auth.initError" class="min-h-screen flex items-center justify-center bg-slate-50">
    <div class="bg-white rounded-2xl shadow-xl border border-slate-200 p-8 w-full max-w-sm text-center">
      <div class="text-4xl mb-3">📡</div>
      <h1 class="text-lg font-bold text-slate-800">暂时连不上服务器</h1>
      <p class="text-sm text-slate-500 mt-2">{{ auth.initError }}</p>
      <p class="text-xs text-slate-400 mt-1">登录状态仍然保留，服务恢复后刷新即可继续，无需重新登录。</p>
      <button
        class="mt-5 w-full py-2.5 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium rounded-lg transition disabled:opacity-50"
        :disabled="auth.loading"
        @click="auth.restore()"
      >
        {{ auth.loading ? '重试中…' : '重试' }}
      </button>
    </div>
  </div>
  <AppShell v-else-if="auth.isAuthenticated" />
  <LoginPage v-else />
</template>
